// src/hooks/useIsAdmin.js
import { useContext } from 'react';
import UserContext from '../contexts/UserContext';

const useIsAdmin = () => {
  const { user } = useContext(UserContext);
  return user?.isAdmin === true;
};

export default useIsAdmin;
